export default __webpack_public_path__ + "static/worksans-medium-webfont-61f26d2037898a07bcce62a364fe1074.woff2";